import cn from 'classnames';
import React from 'react';
import { Icon } from '../../Icon';

export enum CheckboxFill {
  TRANSPARENT = 'bg-transparent',
  WHITE = 'bg-white',
}

interface ICheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'className' | 'name' | 'checked' | 'onChange'> {
  label: React.ReactNode;
  name: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  fill?: CheckboxFill;
}

export const Checkbox: React.FC<ICheckboxProps> = ({
  label,
  name,
  onChange,
  checked = false,
  fill = CheckboxFill.TRANSPARENT,
  ...restProps
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label htmlFor={name} className='m-0 flex min-h-5 items-center gap-2 text-body-500 leading-tight text-eggplant'>
      <span className='relative size-[26px] shrink-0'>
        <input
          {...restProps}
          className={cn(
            '!m-0', // override for default checkbox top margin from bootstrap3.css
            'size-full appearance-none !rounded-lg border-2 border-eggplant',
            'outline-2 !outline-offset-1 !outline-eggplant !ring-0 active:!outline-eggplant',
            fill
          )}
          type='checkbox'
          name={name}
          id={name}
          checked={checked}
          onChange={handleChange}
        />
        {checked && (
          <span className='absolute left-0 top-0 z-0 flex size-full items-center justify-center text-eggplant'>
            <Icon name='check' size={16} />
          </span>
        )}
      </span>

      <span className='mt-0.5 line-clamp-2'>{label}</span>
    </label>
  );
};
